export type BlobStream = ReadableStream<Uint8Array>;

export const streamToFile = async (
  stream: BlobStream,
  filename: string,
  mimeType: string = "application/octet-stream"
): Promise<File> => {
  const blob = await streamToBlob(stream, mimeType);
  // create a File from the Blob
  return new File([blob], filename, { type: mimeType });
};

export const streamToBlob = async (
  stream: BlobStream,
  _mimeType: string = "application/octet-stream"
): Promise<Blob> => {
  if (!stream) {
    throw new Error("invalid stream");
  }
  const response = new Response(stream);

  if (!response.ok && response.status !== 0) {
    throw new Error(`invalid response with status: ${response.status}`);
  }

  try {
    return await response.blob();
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : `${error}`);
  }
};

export const fileToStream = (file: File): BlobStream => {
  return file.stream();
};
